import { render, staticRenderFns } from "./PurchaseDashboard.vue?vue&type=template&id=75e944b7"
import script from "./PurchaseDashboard.vue?vue&type=script&lang=js"
export * from "./PurchaseDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports